/**
 * Dedicated function for checking if product can have accounts.
 * Currently only doBoard product is supported. This function is used as integral part for
 * accounts support.
 *
 * @param {object} product
 * @return {boolean}
 */
export default (product) => {
    return product?.product_id === 7;
}
